import React, { Fragment } from "react";

const Button = React.memo((props) => {
  const {
    className = "btn btn-color",
    onClick,
    label,
    type = "button",
    disabled = false,
    style,
    dataToggle,
    dataOriginalTitle,
    dataTarget,
    dataDismiss,
    id = "",
  } = props;

  return (
    <Fragment>
      <button
        id={id}
        className={className}
        style={style}
        type={type}
        onClick={onClick}
        disabled={disabled}
        data-toggle={dataToggle}
        data-original-title={dataOriginalTitle}
        data-target={dataTarget}
        data-dismiss={dataDismiss}
      >
        {label}
      </button>
    </Fragment>
  );
});
export default Button;
